import React from 'react';
import direction from '../../styles/direction.module.scss';
import {isValidOperator} from '../../utils/filters';
import {StringInputProps} from './StringInput';

export const OperatorInput = ({
    value,
    handleMouseDown,
    handleChange,
    handleKeyDown,
    inputRef,
    onFocus
}: StringInputProps) => {
    const validateAndChange = value => {
        if (value === '' || isValidOperator(value)) {
            handleChange(value);
        }
    };

    return (
        <input
            type={'text'}
            ref={inputRef}
            value={value}
            onKeyDown={handleKeyDown}
            onChange={e => validateAndChange(e.target.value)}
            onMouseDown={handleMouseDown}
            className={direction.ltrDirection}
            onFocus={onFocus}
        />
    );
};
